export function touchElement(selector, callback, scope) {
    if (scope === void 0) { scope = document; }
    var element = scope.querySelector(selector);
    return element && callback(element);
}
